function bytesToProperUnit(size: number, precision: number = 2, chunkSize: number = 1000): string {
    if (!Number.isFinite(size) || size < 0) {
        return '0 B';
    }

    if (!Number.isFinite(precision) || precision < 0) {
        precision = 2;
    }

    if (!Number.isFinite(chunkSize) || chunkSize <= 1) {
        chunkSize = 1000;
    }

    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let value = size;
    let unitIndex = 0;

    while (value >= chunkSize && unitIndex < units.length - 1) {
        value /= chunkSize;
        unitIndex++;
    }

    return `${value.toFixed(precision)} ${units[unitIndex]}`;
}

// ----------------------------------------------------------------------------

export default bytesToProperUnit;
